<template>
  <div class="index-view" v-loading="loading" :style="{ '--height': height, }">
    <div class="index-view-top">
      <div @click="show = true" class="count">
        <img v-if="languageType == 'Chinese'" src="../assets/200.png" />
        <img v-if="languageType == 'English'" src="../assets/201.png" />
        <img v-if="languageType == 'Traditional'" src="../assets/200.png" />
        <img v-if="languageType == 'Japanese'" src="../assets/203.png" />
        <img v-if="languageType == 'Vietnamese'" src="../assets/204.png" />
        <img v-if="languageType == 'Malay'" src="../assets/205.png" />
        <img v-if="languageType == 'Hindi'" src="../assets/206.png" />
        <img v-if="languageType == 'Thai'" src="../assets/207.png" />
        <img v-if="languageType == 'Russian'" src="../assets/208.png" />
        <img v-if="languageType == 'Indonesian'" src="../assets/209.png" />
      </div>
      <div class="toRegister" @click="toRegister">{{ $t("register.toRegister") }}</div>
    </div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div @click="changeLanguageType('Chinese')">简体中文</div>
          <div @click="changeLanguageType('English')">English</div>
          <div @click="changeLanguageType('Traditional')">繁體中文</div>
          <div @click="changeLanguageType('Japanese')">日本語</div>
          <div @click="changeLanguageType('Vietnamese')">Tiếng Việt</div>
          <div @click="changeLanguageType('Malay')">Malaysia</div>
          <div @click="changeLanguageType('Hindi')">हिंदीName</div>
          <div @click="changeLanguageType('Thai')">ภาษาไทย</div>
          <div @click="changeLanguageType('Russian')">Русский</div>
          <div @click="changeLanguageType('Indonesian')">bahasa Indonesia</div>
        </div>
        <div />
      </div>
    </van-overlay>
    <div class="welcome">
      <div>{{ $t("register.welcome") }}</div>
      <div class="logo"><img src="../assets/768.png" alt=""></div>
    </div>
    <div class="login-tips">{{ $t("register.login") }}</div>
    <van-cell-group inset>
      <img class="left" src="../assets/1000.png" alt="">
      <van-field v-model="account" :placeholder="tips1" />
    </van-cell-group>
    <van-cell-group inset>
      <img class="left" src="../assets/1001.png" alt="" />
      <van-field v-model="password" type="password" :placeholder="tips2" />
    </van-cell-group>
    <div class="forget">
      <div @click="toForget">{{ $t("register.forget") }}</div>
    </div>
    <div class="nowLogin" @click="toNowLogin">
      <div>
        <p>{{ $t("register.nowLogin") }}</p>
      </div>
    </div>
    <div class="nologin">
      <div @click="toNoLogin">
        <img src="../assets/1002.png" alt="" />
        <p>{{ $t("phone.xqgg") }}</p>
      </div>
      <div @click="contact">
        <img src="../assets/1003.png" alt="" />
        <p>{{ $t("phone.llwm") }}</p>
      </div>
    </div>
    <div class="agreement">
      <p>{{ $t("register.agreement") }}</p>
      <p @click="user(0)">《{{ $t("register.user") }}》</p>
      <p @click="user(1)">《{{ $t("register.policy") }}》</p>
    </div>
  </div>
</template>

<script>
import { login, contact } from '@/utils/request'
export default {
  inject: ['reload'],
  data() {
    return {
      account: '',
      password: '',
      show: false,
      languageType: '',
      languageLists: '',
      loading: '',
      height: '', //屏幕高度
      tips1: this.$t('phone.yhm'), //请输入您的用户名
      tips2: this.$t('phone.mm'), //请输入您的密码
      contactUrl: ''
    }
  },
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  //获取屏幕高度
  async beforeMount(height) {
    this.languageType = (await localStorage.getItem('language')) || 'Chinese'
    this.languageLists = this.$t('lang.langlist')
  },
  mounted() {
    contact().then(res => {
      if (res.code == '200') {
        this.contactUrl = res.data.url
      }
    })
  },
  methods: {
    contact() {
      if (this.contactUrl) {
        window.open(this.contactUrl, '_blank')
      }
    },
    changeLanguageType(item) {
      let _this = this
      _this.languageType = item
      localStorage.setItem('language', item)
      _this.loading = true
      _this.show = false
      setTimeout(() => {
        _this.$i18n.locale = item
        _this.languageType = localStorage.getItem('language') || 'Chinese'
        _this.languageLists = this.$t('lang.langlist')
        _this.reload()
        _this.loading = false
      }, 1000)
    },
    user(type) {
      this.$router.push('/Privacypolicy?type=' + type)
    },
    toNoLogin() {
      localStorage.setItem('token', '')
      this.$router.push('/luckyhash')
    },
    toNowLogin() {
      if (this.account && this.password) {
        login({
          account: this.account,
          password: this.password
        }).then(res => {
          if (res.code == '200') {
            this.$toast.success(this.$t('prompt.loginsuccessful'))
            localStorage.setItem('token', res.data.token)
            this.$store.commit('changeUserName', this.account)
            if (res.data.bindWalletStatus == true) {
              setTimeout(() => {
                this.$router.push('/luckyhash')
              }, 500)
            } else {
              setTimeout(() => {
                this.$router.push('/address')
              }, 500)
            }
          } else {
            this.$toast.success(res.msg)
          }
        })
      } else {
        this.$toast.fail(this.$t('prompt.null'))
      }
    },
    toRegister() {
      this.$router.push('/register')
    },
    toForget() {
      this.$router.push('/forget')
    }
  }
}
</script>
<style lang="scss" scoped>
.index-view {
  width: 100vw;
  height: var(--height);
  background: #020017;

  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: unset;
  }

  /deep/ .van-field__control {
    color: #ffffff !important;
  }

  .van-cell {
    background: #110E31;
    //border-radius: 1.375rem;
    padding-left: 0.5rem;
  }

  .van-cell-group {
    background: #110E31;
    border-radius: 1.375rem;
    margin: 0 1.875rem 1rem;
    display: flex;
    padding-left: 1rem;
    align-items: center;

    .left {
      width: 1.25rem;
      height: 1.25rem;
    }
  }

  .nowNoLogin {
    padding: 0 1.875rem;
    margin-bottom: 0.9375rem;

    >div {
      width: 100%;
      height: 2.6875rem;
      border: 0.0625rem solid #f8c007;
      border-radius: 1.375rem;
      display: flex;
      align-items: center;
      justify-content: center;

      >p {
        font-size: 0.9375rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #f8c007;
      }
    }
  }

  .agreement {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 6.75rem;

    >p {
      font-size: 0.6875rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
    }

    >p:nth-child(1) {
      color: #666666;
    }

    >p:nth-child(2) {
      color: #ffc400;
    }

    >p:nth-child(3) {
      color: #ffc400;
    }
  }

  .no-account {
    display: flex;
    align-items: center;
    justify-content: center;

    >p {
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
    }

    >p:nth-child(1) {
      color: #999999;
    }

    >p:nth-child(2) {
      color: #ffffff;
    }
  }

  .nowLogin {
    padding: 0 1.875rem;
    margin-bottom: 0.9375rem;

    >div {
      width: 100%;
      height: 2.6875rem;
      background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
      border-radius: 1.375rem;
      display: flex;
      align-items: center;
      justify-content: center;

      >p {
        font-size: 0.9375rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #0c0b0b;
      }
    }
  }

  .forget {
    padding: 0 2rem 1rem;
    display: flex;

    >div {
      margin-left: auto;
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #f8c007;
    }
  }

  .login-tips {
    font-size: 0.9375rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    padding: 0 1.875rem 2.1875rem;
  }

  .welcome {
    padding: 1.5625rem 1.875rem 0.9375rem;
    display: flex;

    >div:nth-child(1) {
      font-size: 1.25rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      margin-right: 0.625rem;
    }

    >div:nth-child(2) {
      font-size: 1.25rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #f8c007;
    }
  }

  .logo {
    >img {
      display: block;
      width: 61.5px;
      height: 38px;
    }
  }

  .block {
    width: 148px;
    // height: 299px;
    background: #242121;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    position: absolute;
    top: 3rem;
    left: 15px;
    padding: 15px 15px 0 15px;

    div {
      text-align: center;
      margin-bottom: 15px;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .nologin {
    display: flex;
    justify-content: space-between;
    padding: 0 1.875rem;

    >div {
      display: flex;
      align-items: center;

      >p {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #565656;
        padding-left: 4px;
      }

      >img {
        width: 16px;
        height: 16px;
      }
    }
  }

  .index-view-top {
    height: 3.125rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.9375rem;

    .count {
      >img {
        width: 24px;
        height: 24px;
      }
    }

    .toRegister {
      font-size: 0.9375rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue